import { LoadingIndicator } from "@openai/apps-sdk-ui/components/Indicator";
// import { useEffect, useState } from "react";
// import { useApp } from "@modelcontextprotocol/ext-apps/react";
import type { App as McpApp } from "@modelcontextprotocol/ext-apps";
import { useOpenAiGlobal } from "../use-openai-global";

interface ResumeDiagnoseOutput {
  toolName: string;
  success: boolean;
  diagnoseResult?: any;
}

export default function App() {
  // const [data, setData] = useState<ResumeDiagnoseOutput | null>(null);
  // const { app, error } = useApp({
  //   appInfo: { name: "Show Resume Diagnose Result", version: "1.0.0" },
  //   capabilities: {},
  //   onAppCreated: (app: McpApp) => {
  //     app.ontoolresult = (result: any) => {
  //       setData(result.structuredContent as unknown as ResumeDiagnoseOutput);
  //     };
  //   },
  // });

  // useEffect(() => {
  //   if (error) {
  //     console.error("Error initializing app:", error);
  //   }
  //   if (app) {
  //     console.log("App initialized successfully:", app);
  //     console.log("tool name:", data?.toolName);
  //     console.log("diagnose result:", data?.diagnoseResult);
  //     console.log("success:", data?.success);
  //   }
  // }, [error, app, data]);
  const toolOutput = useOpenAiGlobal("toolOutput") as ResumeDiagnoseOutput | null;
  const resumeDiagnose = toolOutput?.diagnoseResult;

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
      { resumeDiagnose ? (
        <div className="flex items-center gap-2">
          <span>Resume Diagnosed Finish!</span>
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <LoadingIndicator
            size = {20}
            strokeWidth={2}
          />
          Resume Diagnosing...
        </div>
      )
      }
      {/* <pre>{JSON.stringify(resumeStruct, null, 2)}</pre> */}
    </div>
  );
}
